// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"aba42a4e","82":"c3b60857","126":"c3e94e58","411":"2898db52","474":"1c6fc33b","518":"19d7b998","545":"017c72cf","650":"9004b2c1","666":"85476879","763":"07cf1330","798":"742379af","895":"0c9192f3"}[chunkId] + ".chunk.js";
};